export default __webpack_public_path__ + "static/emp-icn3-b0d87250d5188d7843677c590eaf2881.png";